import Constants from '../constants/Constants';
import Messages from './../constants/Messages';
import forge from 'node-forge';

const LoginValidations = {
    /** ---------------------------------------------------------------------------------------------
     * Method to validate email
     * @param {*} email 
     * @returns 
     */
    validateEmail : (email) => {
        // Conditions to be added
        let error = null;
        if(!email || email.length === 0) {
            error = Messages.LOGIN.FORM_FIELDS.EMAIL.ERROR.NO_EMAIL_ENTERED;
        }
        else if (!Constants.VALIDATION_PATTERNS.EMAIL.test(email)) {
            error = Messages.LOGIN.FORM_FIELDS.EMAIL.ERROR.INVALID_EMAIL;
        }
        return error;
    },
    /** ---------------------------------------------------------------------------------------------
     * Method to validate password
     * @param {*} password 
     * @returns 
     */
    validatePassword : (password) => {
        let error = null;
        if(!password || password.length === 0) {
            error = Messages.LOGIN.FORM_FIELDS.PASSWORD.ERROR.NO_PASSWORD_ENTERED;
        }
        return error;
    },

    /** ---------------------------------------------------------------------------------------------
     * Method to validate new password
     * @param {*} password 
     * @returns 
     */
    validateNewPassword : (password) => {
        let error = null;
        if(!password || password.length === 0) {
            error = Messages.RESET_PASSWORD.FORM_FIELDS.NEW_PASSWORD.ERROR.NO_PASSWORD_ENTERED;
        }
        else if(password.length < 6) {
            error = Messages.RESET_PASSWORD.FORM_FIELDS.NEW_PASSWORD.ERROR.LENGTH_NOT_MET;
        }
        else if(password.length > 15) {
            error = Messages.RESET_PASSWORD.FORM_FIELDS.NEW_PASSWORD.ERROR.LENGTH_EXCEEDED;
        }
        return error;
    },

    /** ---------------------------------------------------------------------------------------------
     * Method to confirm whether both passwords match
     * @param {*} password 
     * @param {*} confirmPassword 
     * @returns 
     */
    validateConfirmPassword : (password, rePassword) => {
        let error = LoginValidations.validatePassword(rePassword);
        if(error === null) {
            if(rePassword !== password) {
                error = Messages.RESET_PASSWORD.FORM_FIELDS.RE_PASSWORD.ERROR.NO_MATCH;
            }
        }
        return error;
    }
}

/**
 * Used to encrypt data.
 * @param {string} publicKeyPem 
 * @param {object} data 
 * @returns 
 */
export const encryptData = ( publicKeyPem, data ) => {
    try {
        const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
        const encryptedLoginData = publicKey.encrypt(data);
        const encryptedBase64LoginData = forge.util.encode64(encryptedLoginData);
        return encryptedBase64LoginData;
    } catch (error) {
        throw new Error(error); 
    }
}

export default LoginValidations;